<svg class="icon">
  <use [attr.href]="'assets/icons/bootstrap-italia-icons.svg#' + icona"></use>
</svg>
